import React from 'react';

const FinancialPlanningIncomeEarnerDeathBottomline = () => {
  const benefits = [
    {
      title: "Comprehensive Insurance Coverage",
      description: "Establishing adequate life insurance with appropriate riders ensures immediate financial security for dependents, covering both short-term expenses and long-term financial goals without compromising family lifestyle."
    },
    {
      title: "Structured Asset Documentation",
      description: "Creating a complete inventory of assets, accounts, and liabilities with centralized access instructions enables family members to quickly locate and utilize available resources during an emotionally challenging time."
    },
    {
      title: "Streamlined Estate Transfer",
      description: "Implementing proper estate planning tools including wills, trusts, and beneficiary designations prevents probate delays and ensures assets transfer efficiently to intended recipients without legal complications."
    },
    {
      title: "Financial Education Framework",
      description: "Developing financial literacy among family members and establishing relationships with trusted advisors creates a support system that helps survivors make informed decisions when assuming financial responsibility."
    }
  ];

  return (
    <div className="w-full bg-gradient-to-br from-[#113262] to-[#1C52A0] py-12 px-8">
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        <div className="text-center mb-16">
          <h2 className="text-white text-2xl md:text-3xl lg:text-4xl font-bold mb-4">
            Bottomline: Benefits of Planning for Sudden Death of Income Earner
          </h2>
          <div className="w-24 h-1 bg-[#F49611] mx-auto mt-4"></div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
          {benefits.map((benefit, index) => (
            <div key={index} className="relative">
              {/* Decorative number */}
              <div className="absolute -left-8 top-0 text-6xl font-bold text-white opacity-30">
                {index + 1}
              </div>
              
              {/* Content */}
              <div className="relative">
                <div className="flex items-start space-x-4">
                  {/* Vertical line decoration */}
                  <div className="hidden md:block w-1 h-full bg-gradient-to-b from-[#F49611] to-transparent"></div>
                  
                  <div className="flex-1">
                    <h3 className="text-[#F49611] text-xl font-semibold mb-4">
                      {benefit.title}
                    </h3>
                    <p className="text-white/80 text-base leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FinancialPlanningIncomeEarnerDeathBottomline;